import {ColorValue, Platform, TextStyle} from 'react-native';
import {RoundedBtnDescriberProps} from 'src/components/elements/buttonDescriptor/DescriptorType';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';

export function roundedBtnColorDescriptor(props: RoundedBtnDescriberProps): {
  [index: string]: ColorValue;
} {
  const disabledColor = Styles.Colors.CompanyKitchen.lightGray;
  let buttonColor = props.disabled
    ? disabledColor
    : props.color || Styles.Colors.CompanyKitchen.green;
  let fillColor = Styles.Colors.CompanyKitchen.green;
  let textColor = Styles.Colors.CompanyKitchen.black;

  if (props.buttonType === 'outline') {
    buttonColor = props.disabled
      ? disabledColor
      : props.color || Styles.Colors.CompanyKitchen.black;
    fillColor = Styles.transparent;
    textColor = props.disabled
      ? disabledColor
      : props.color || Styles.Colors.CompanyKitchen.black;
  } else {
    fillColor = props.disabled
      ? disabledColor
      : props.color || Styles.Colors.CompanyKitchen.green;
    textColor = props.disabled
      ? Styles.white
      : Styles.Colors.CompanyKitchen.black;
    buttonColor = props.disabled
      ? disabledColor
      : props.color || Styles.Colors.CompanyKitchen.green;
  }
  return {fillColor, textColor, buttonColor};
}

export function roundAppButtonSolidTextStyle(disabled: boolean): TextStyle {
  return disabled
    ? {
        color: Styles.white,
      }
    : {
        color: Styles.Colors.CompanyKitchen.black,
      };
}

export function roundAppButtonOutlineTextStyle(disabled: boolean): TextStyle {
  return disabled
    ? {
        color: Styles.Colors.CompanyKitchen.black,
      }
    : {
        color: Styles.Colors.CompanyKitchen.black,
      };
}

export function checkRoundedBtnColor(type?: ButtonType): string {
  return type === ButtonType.outline
    ? Styles.Colors.CompanyKitchen.black
    : Styles.Colors.CompanyKitchen.green;
}

export function getSaveBtnManageAccount(handleSave) {
  return (
    <RoundedButton
      buttonType={ButtonType.action}
      text={Localized.Buttons.save}
      onPress={handleSave}
      accessible={true}
      addShadow={false}
      accessibilityLabel={Localized.Buttons.save}
      accessibilityRole="button"
      role="button"
      testID={'qa_btn_Save'}
      color={Styles.Colors.CompanyKitchen.green}
      aria-label={Localized.Buttons.save}
      containerStyle={
        Platform.OS != 'web'
          ? {
              alignItems: 'center',
              left: Styles.Spacing.m3,
              right: Styles.Spacing.m3,
              bottom: Styles.Spacing.m3,
            }
          : {
              alignItems: 'center',
              left: 'auto',
              right: 'auto',
              marginHorizontal: Styles.Spacing.m3,
              bottom: Styles.Spacing.m3,
              width: '100%',
              maxWidth: Styles.Spacing.m8,
            }
      }
    />
  );
}

export function getTertiaryCTATextStyle(): TextStyle {
  return {
    color: Styles.Colors.CompanyKitchen.black,
  };
}

export function buttonTextFontFamily(): string {
  return Styles.FontFamily.latoRegular;
}
export function redeemRewardRoundedBtnColor(_type?: ButtonType): string {
  return Styles.Colors.Canteen.primary;
}

export function redeemRewardIconColor(): string {
  return Styles.Colors.Canteen.primary;
}

export default {
  roundedBtnColorDescriptor,
  roundAppButtonSolidTextStyle,
  roundAppButtonOutlineTextStyle,
  checkRoundedBtnColor,
  getSaveBtnManageAccount,
  getTertiaryCTATextStyle,
  buttonTextFontFamily,
  redeemRewardRoundedBtnColor,
  redeemRewardIconColor,
};
